import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Table from "react-bootstrap/Table"
import Button from '@mui/material/Button';
import "datatables.net-dt/css/dataTables.dataTables.min.css"
import DataTable from "datatables.net-dt/js/dataTables.dataTables.min.js"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {NavLink} from "react-router-dom"


const DeleteLocation = () => {
  const[data,setData]=useState([])
   useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/location`)
    .then((res)=>{
      setData(res.data)
    })
    .catch((err)=>{
      alert("Error Fetching locations")
    })
    setTimeout(()=>{
          new DataTable('#locationTable');

    },1000)
  })

  const deleteLocationData =(sid)=>{
    axios.delete(`https://backendsurgylife-1.onrender.com/location/${sid}`)
    .then((res)=>{
      alert("Location Deleted Successfully")
    })
    .catch((err)=>{
      alert("Error Deleting Location")
    })
  }


  return (
      <main>    
        <section>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                           <Table striped bordered hover id='locationTable'>
                    <thead>
                    <tr>
                      <th>Treatment Name</th>
                      <th>Location </th>
                    
                         <th>Action</th>
                      
                    </tr>
                 </thead>

                     <tbody>
                            {
                              data.map((location)=>{
                                return(
                                    <tr key={location._id}>
                                        <td>{location.trname}</td>
                                        <td>{location.location}</td>
                                    
                                      
                          <td className='d-flex '>
                        <Button 
                       variant="contained"
                        color='error'
                        className='me-2'
                         onClick={()=>{deleteLocationData(location._id)}}>
                     <DeleteIcon/>
                          </Button>
                        
                         <Button 
                       variant="outlined"
                        color='success'
                       >
                        <NavLink to={`/editlocation/${location._id}`}>
                                <EditIcon/>
                        </NavLink>
               
                          </Button>

                                         
                                        </td>
                                    </tr>
                                )
                              })
                            }
                    </tbody>

                 </Table> 
    
                 </div>
             
                </div>
           
            </div>

        </section>
        
    </main>
  )
}

export default DeleteLocation
